import React from 'react'
import { connect } from 'react-redux'
import {
    DisplaysAddVirtualDeviceMethods,
    IAddVirtualDeviceProps,
    IState,
    VirtualDeviceGroupOption,
    VirtualDeviceLicenseOption,
    VirtualDeviceTagOption,
    VirtualDeviceTimezoneOption,
} from './displays__addVirtualDevice.local.methods'
import { SelectMapDialog } from 'features/map'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import EditText from 'blocks.simple/editText/editText'
import { Radio } from 'atoms/Radio'
import Button from 'blocks.simple/button/button'
import { Scrollbars } from 'react-custom-scrollbars'
import translate from 'core/translate'
import helpersDisplays from 'core/helpers/_digitalSignages'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import { cn } from 'ethcss'
import styles from './displays__addVirtualDevice.jcss'
import { colors, grid, item } from 'theme'
import { text as textStyles } from 'theme'
import { Typography } from 'atoms/Typography'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import { displaysActions } from '../displays.state'
import Icon from 'blocks.simple/icon/icon'
import { isVacantCountNull, noEmoji } from 'core/utils/displayUtil'
import Link from 'blocks.simple/link/link'
import { OpenStreetMap } from '../../../features/map/molecules/OpenStreetMap/OpenStreetMap-view'
import moment from 'moment'
import helpers from '../../../core/helpers'

const DisplaysAddVirtualDevice = (p_: IAddVirtualDeviceProps) => {
    const {
        state,
        setState,
        onMapClose,
        getLocation,
        onChangePlacemarkGeometry,
        onChangeLocation,
        getCenter,
        onChangeAddress,
        getAddress,
        setData,
        onValidateSymbolNumber,
        closeModal,
        onSave,
        inputNullCheck,
    } = DisplaysAddVirtualDeviceMethods(p_)

    const renderMap = () => {
        const { active } = state

        const mapType = window?.spconfig?.map?.type

        return mapType !== 'yandex' && mapType !== 'google' ? (
            <OpenStreetMap
                onClose={onMapClose}
                isOpen={active}
                location={getLocation()}
                onChangeLocation={onChangeLocation}
                onChangePlacemarkGeometry={onChangePlacemarkGeometry}
            />
        ) : (
            <SelectMapDialog
                onClose={onMapClose}
                isOpen={active}
                location={getLocation()}
                center={getCenter()}
                onChangeLocation={onChangeLocation}
                onChangeAddress={onChangeAddress}
                onChangePlacemarkGeometry={onChangePlacemarkGeometry}
            />
        )

        // return (
        //     <SelectMapDialog
        //         onClose={this.onMapClose}
        //         isOpen={active}
        //         location={this.getLocation()}
        //         center={this.getCenter()}
        //         onChangeLocation={this.onChangeLocation}
        //         onChangeAddress={this.onChangeAddress}
        //         onChangePlacemarkGeometry={this.onChangePlacemarkGeometry}
        //     />
        // )
    }

    const checkEmptyLicences = (licences: any) => {
        return licences.some((licence: any) => licence.vacantCount)
    }

    const renderCustomOptions = (option: any) => {
        return (
            <div className={styles.licenseOption}>
                <div className={styles.licenseOptionRow} style={{ marginBottom: option.id ? 6 : 0 }}>
                    <div className={styles.licenseOptionName}>{option.name}</div>
                    {option.id && (
                        <div className={styles.licenseOptionDesc}>
                            {translate('licenseIdN')}: <span>{option.id}</span>
                        </div>
                    )}
                </div>
                {option.id && (
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseOptionDesc}>
                            {translate('freeN')}:{' '}
                            <span>
                                {option.vacantCount}/<span>{option.devicesCount}</span>
                            </span>
                        </div>
                        <div className={styles.licenseOptionDesc}>
                            {translate('activeBeforeN')}:{' '}
                            <span>
                                {option.expiredAt
                                    ? moment(option.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const renderCustomSelected = (licenseId: number | null | undefined) => {
        const license = state.licensesData.find((item) => item.id === licenseId)
        return (
            license && (
                <div>
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseOptionName}>{license.name}</div>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('licenseIdN')}: <span>{license.id}</span>
                        </div>
                    </div>
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('freeN')}:{' '}
                            <span>
                                {license.vacantCount}/<span>{license.devicesCount}</span>
                            </span>
                        </div>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('activeBeforeN')}:{' '}
                            <span>
                                {license.expiredAt
                                    ? moment(license.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </span>
                        </div>
                    </div>
                </div>
            )
        )
    }

    let disabled = false

    if (helpersDisplays.isCheckLicenseQ()) {
        if (!helpersDisplays.checkActualLicense(state.currentLicense?.id, state.licensesData)) {
            disabled = true
        }
    }

    return (
        <div className={styles.scrollRoot}>
            <Scrollbars style={{ width: '100%', height: '100%' }}>
                <form
                    className={styles.wrapper}
                    //onSubmit={this.submit}
                >
                    {isVacantCountNull(state.licensesData) ? (
                        <>
                            <Typography type="title" className={cn(styles.title, textStyles['mdPlus'])}>
                                {translate('virtualDeviceSettings')}
                            </Typography>
                            <div className={styles.content}>
                                <div className={styles.formWrapper}>
                                    <div className={styles.form}>
                                        <div className={styles.leftColumnContent}>
                                            <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                                <EditText
                                                    validationBorder={!!state.data.error}
                                                    label={
                                                        <Typography
                                                            type="title"
                                                            className={cn(
                                                                textStyles.up,
                                                                textStyles.centerBlock,
                                                                textStyles['normalPlus'],
                                                                grid.mb_micro
                                                            )}
                                                        >
                                                            {translate('name')}
                                                        </Typography>
                                                    }
                                                    mod="withBorder"
                                                    id="name"
                                                    type="text"
                                                    className={cn(textStyles.center, styles.noBoxShadow)}
                                                    value={state.data.name}
                                                    onChange={(name: string) => {
                                                        setData({ name })
                                                        inputNullCheck(name, 'name')
                                                    }}
                                                    disabled={disabled}
                                                />
                                                <div
                                                    className={cn(
                                                        grid.mt_micro,
                                                        textStyles.centerBlock,
                                                        state.data.error ? '' : item.hidden,
                                                        styles.errorInputText
                                                    )}
                                                >
                                                    {translate('fieldIsRequired')}
                                                </div>
                                            </div>
                                            <div
                                                className={cn(grid.mb_md, { [styles.disabled]: disabled })}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                }}
                                            >
                                                <EditText
                                                    label={
                                                        <Typography
                                                            type="title"
                                                            className={cn(
                                                                textStyles.up,
                                                                textStyles.centerBlock,
                                                                textStyles['normalPlus'],
                                                                grid.mb_micro
                                                            )}
                                                        >
                                                            {translate('address')}
                                                        </Typography>
                                                    }
                                                    mod="withBorder"
                                                    id="address"
                                                    type="text"
                                                    icon="location"
                                                    className={cn(textStyles.center, styles.noBoxShadow)}
                                                    onIconClick={() =>
                                                        setState((prevState) => ({ ...prevState, active: true }))
                                                    }
                                                    value={getAddress()}
                                                    onChange={(address: string) => {
                                                        setData({ address })
                                                    }}
                                                    disabled={disabled}
                                                />
                                            </div>
                                        </div>
                                        <div className={styles.descriptionWrapper}>
                                            <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                                <EditText
                                                    label={
                                                        <Typography
                                                            type="title"
                                                            className={cn(
                                                                textStyles.up,
                                                                textStyles.centerBlock,
                                                                textStyles['normalPlus'],
                                                                grid.mb_micro
                                                            )}
                                                        >
                                                            {translate('description')}
                                                        </Typography>
                                                    }
                                                    mod="withBorder"
                                                    id="description"
                                                    className={cn(styles.noBoxShadow)}
                                                    type="area"
                                                    rows="6"
                                                    value={state.data.description}
                                                    onChange={(description: string) => {
                                                        setData({ description })
                                                    }}
                                                    disabled={disabled}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.leftColumnContent}>
                                        <div className={cn(grid.mb_md, item.rel, { [styles.disabled]: disabled })}>
                                            {p_.groups && (
                                                <Dropdown
                                                    id="group"
                                                    label={
                                                        <Typography
                                                            type="title"
                                                            className={cn(
                                                                textStyles.up,
                                                                textStyles.centerBlock,
                                                                textStyles['normalPlus'],
                                                                grid.mb_micro
                                                            )}
                                                        >
                                                            {translate('group')}
                                                        </Typography>
                                                    }
                                                    value={state.data.groupId}
                                                    options={p_.groups}
                                                    centered
                                                    searchable
                                                    type="tree"
                                                    onChange={(selected: VirtualDeviceGroupOption) => {
                                                        setData({ groupId: selected.id })
                                                    }}
                                                    disabled={disabled}
                                                />
                                            )}
                                        </div>
                                        <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                            <Typography
                                                type="title"
                                                className={cn(
                                                    textStyles.up,
                                                    textStyles.centerBlock,
                                                    textStyles['normalPlus'],
                                                    grid.mb_mini
                                                )}
                                            >
                                                {translate('timezones')}
                                            </Typography>
                                            <Checkbox
                                                className={cn(grid.p_micro)}
                                                label={
                                                    <div className={cn(grid.pl_mini, grid.pr_mini, textStyles.normal)}>
                                                        <Typography type="title">
                                                            {translate('useGroupTimezone')}
                                                        </Typography>
                                                    </div>
                                                }
                                                checked={state.groupTimezone}
                                                onClick={(checked: boolean) => {
                                                    setState((prevState) => ({ ...prevState, groupTimezone: checked }))
                                                }}
                                                disabled={disabled}
                                            />
                                        </div>
                                        <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                            <Dropdown
                                                id={'timezones'}
                                                validationBorder={!!state.data.nullTimezoneError}
                                                placeholder={translate('notSelected')}
                                                value={
                                                    state.groupTimezone
                                                        ? state.parentTimezone
                                                            ? state.parentTimezone
                                                            : state.data.timezone
                                                        : state.data.timezone
                                                }
                                                options={p_.timezones ? p_.timezones : []}
                                                searchable
                                                centered
                                                onChange={(selected: VirtualDeviceTimezoneOption) => {
                                                    setData({
                                                        timezone: selected.id,
                                                        timezoneAbbr: selected.timezoneAbbr,
                                                        timezoneOffset: selected.gmtOffset / 60,
                                                        nullTimezoneError: null,
                                                    })
                                                }}
                                                labelClassName={cn(item.ellipsis)}
                                                disabled={state.groupTimezone || disabled}
                                            />
                                            <div
                                                className={cn(
                                                    grid.mt_micro,
                                                    textStyles.centerBlock,
                                                    state.data.nullTimezoneError ? '' : item.hidden,
                                                    styles.errorInputText
                                                )}
                                            >
                                                {translate('fieldIsRequired')}
                                            </div>
                                        </div>
                                        <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                            <Dropdown
                                                searchable
                                                value={state.data.orientation}
                                                label={
                                                    <Typography
                                                        type="title"
                                                        className={cn(
                                                            textStyles.up,
                                                            textStyles.centerBlock,
                                                            textStyles['normalPlus'],
                                                            grid.mb_micro
                                                        )}
                                                    >
                                                        {translate('orientation')}
                                                    </Typography>
                                                }
                                                centered
                                                options={helpersDisplays.getOrientations()}
                                                onChange={(value: { id: string | number }) => {
                                                    setData({ orientation: value.id })
                                                }}
                                                disabled={disabled}
                                            />
                                        </div>
                                        {helpers.isAvailableAction(null, {
                                            key: 'DSNotifications',
                                            action: 'update',
                                        }) && (
                                            <>
                                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                                    <Dropdown
                                                        searchable
                                                        value={
                                                            state.data.DSNotificationsData &&
                                                            state.data.DSNotificationsData.unitId
                                                        }
                                                        placeholder={translate('notSelected')}
                                                        label={
                                                            <Typography
                                                                type="title"
                                                                className={cn(
                                                                    textStyles.up,
                                                                    textStyles.centerBlock,
                                                                    textStyles['normalPlus'],
                                                                    grid.mb_micro
                                                                )}
                                                            >
                                                                {translate('DSNotificationUnit')}
                                                            </Typography>
                                                        }
                                                        centered
                                                        options={helpersDisplays.getUnitListOptions(state.unitList)}
                                                        onChange={(value: { id: number }) => {
                                                            setData({
                                                                DSNotificationsData: {
                                                                    unitId: value.id,
                                                                    floorId: null,
                                                                },
                                                            })
                                                        }}
                                                        disabled={disabled}
                                                    />
                                                </div>
                                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                                    <Dropdown
                                                        searchable
                                                        value={
                                                            state.data.DSNotificationsData &&
                                                            state.data.DSNotificationsData.floorId
                                                        }
                                                        label={
                                                            <Typography
                                                                type="title"
                                                                className={cn(
                                                                    textStyles.up,
                                                                    textStyles.centerBlock,
                                                                    textStyles['normalPlus'],
                                                                    grid.mb_micro
                                                                )}
                                                            >
                                                                {translate('floor')}
                                                            </Typography>
                                                        }
                                                        centered
                                                        placeholder={translate('notSelected')}
                                                        options={helpersDisplays.getUnitFloorListOptions(
                                                            state.unitList,
                                                            state.data.DSNotificationsData
                                                        )}
                                                        onChange={(value: { id: number }) => {
                                                            if (state.data.DSNotificationsData) {
                                                                setData({
                                                                    DSNotificationsData: {
                                                                        unitId: state.data.DSNotificationsData.unitId,
                                                                        floorId: value.id,
                                                                    },
                                                                })
                                                            }
                                                        }}
                                                        disabled={disabled}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className={styles.rightColumnContent}>
                                        <div
                                            className={cn(styles.displaysAddVirtualDevice__inputWrapper_type_tags, {
                                                [styles.disabled]: disabled,
                                            })}
                                        >
                                            <Dropdown
                                                list={state.data.tags}
                                                hiddenOverflow
                                                options={p_.tagsList ? p_.tagsList : []}
                                                label={
                                                    <Typography
                                                        type="title"
                                                        className={cn(
                                                            textStyles.up,
                                                            textStyles.centerBlock,
                                                            textStyles['normalPlus'],
                                                            grid.mb_micro
                                                        )}
                                                    >
                                                        {translate('tag')}
                                                    </Typography>
                                                }
                                                searchable={true}
                                                multiselect={true}
                                                onChange={(tags: VirtualDeviceTagOption[]) => {
                                                    tags = tags.map((tag) => {
                                                        if (!tag.id && tag.name.match(/#/g)) {
                                                            tag.name = tag.label = tag.name.replace(/#/g, '')
                                                        }
                                                        tag = {
                                                            ...tag,
                                                            name: noEmoji(tag.name),
                                                            label: noEmoji(tag.label),
                                                        }
                                                        return tag
                                                    })
                                                    setData({ tags })
                                                }}
                                                disabled={disabled}
                                                onValidateSymbolNumber={(checked) => onValidateSymbolNumber(checked)}
                                            />
                                        </div>
                                        <div className={grid.mt_mini}>
                                            <Typography className={cn(textStyles.centerBlock)} type="text">
                                                {translate('forAddTagUseEnter')}
                                            </Typography>
                                            {state.validateSymbolNumber && (
                                                <Typography
                                                    className={cn(styles.centerBlock, grid.mt_mini)}
                                                    type="error"
                                                >
                                                    {translate('minTagNumber')}
                                                </Typography>
                                            )}
                                        </div>

                                        {helpersDisplays.isCheckLicenseQ() && (
                                            <div className={cn(grid.mb_md, grid.mt_big, item.rel, styles.lic)}>
                                                <Dropdown
                                                    validationBorder={!!state.data.licensesTypeError}
                                                    id="licensesDataVirtual"
                                                    label={
                                                        <Typography
                                                            type="title"
                                                            className={cn(
                                                                textStyles.up,
                                                                textStyles.centerBlock,
                                                                textStyles['normalPlus'],
                                                                grid.mb_mini
                                                            )}
                                                        >
                                                            {translate('licensesType')}
                                                        </Typography>
                                                    }
                                                    value={state.currentLicense?.id}
                                                    customListElement={renderCustomOptions}
                                                    customButtonContent={renderCustomSelected(state.currentLicense?.id)}
                                                    options={[
                                                        {
                                                            name: translate('notSelected'),
                                                            id: null,
                                                        },
                                                        ...state.licensesData.filter(
                                                            (item: any) => item.id !== state.currentLicense?.id
                                                        ),
                                                    ]}
                                                    placeholder={translate('notSelected')}
                                                    centered
                                                    onChange={(selected: VirtualDeviceLicenseOption) => {
                                                        setState((prevState: IState) => ({
                                                            ...prevState,
                                                            currentLicense: selected,
                                                            data: {
                                                                ...prevState.data,
                                                                licenseId: selected.id,
                                                                licensesTypeError: false,
                                                            },
                                                        }))
                                                    }}
                                                    buttonClassName={'test-choose-license'}
                                                />
                                                <div
                                                    className={cn(
                                                        grid.mt_micro,
                                                        textStyles.centerBlock,
                                                        state.data.licensesTypeError ? '' : item.hidden,
                                                        styles.errorInputText
                                                    )}
                                                >
                                                    {translate('fieldIsRequired')}
                                                </div>
                                            </div>
                                        )}
                                        {helpersDisplays.isCheckLicenseQ() && !checkEmptyLicences(state.licensesData) && (
                                            <div className={styles.noLicensesLeft}>
                                                <Icon type={'info'} color={colors.notificationRed} />
                                                <span>{translate('noLicencesInTariffs')}</span>
                                            </div>
                                        )}
                                        {p_.currentGroup && p_.currentGroup.id !== state.data.groupId && (
                                            <div className={cn(grid.mt_mdPlus, { [styles.disabled]: disabled })}>
                                                <Typography
                                                    className={cn(
                                                        textStyles.centerBlock,
                                                        textStyles.up,
                                                        textStyles['normalPlust']
                                                    )}
                                                    type="title"
                                                >
                                                    {translate('scheduleForDevice')}
                                                </Typography>
                                                <Radio
                                                    className={cn(grid.mt_md)}
                                                    label={
                                                        <Typography type="title">
                                                            {translate('changeCurrentSchedule')}
                                                        </Typography>
                                                    }
                                                    selected={state.data.groupScheduleMode === 'apply'}
                                                    onClick={() => {
                                                        setData({ groupScheduleMode: 'apply' })
                                                    }}
                                                    disabled={disabled}
                                                />
                                                <Radio
                                                    className={cn(grid.mt_mini)}
                                                    label={
                                                        <Typography type="title">
                                                            {translate('remainCurrentSchedule')}
                                                        </Typography>
                                                    }
                                                    selected={state.data.groupScheduleMode === 'ignore'}
                                                    onClick={() => {
                                                        setData({ groupScheduleMode: 'ignore' })
                                                    }}
                                                    disabled={disabled}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>{' '}
                        </>
                    ) : (
                        <div className={styles.content}>
                            <div className={cn(styles.formWrapper, styles.w100)}>
                                <div className={cn(grid.center)}>
                                    <div className={cn(grid.mb_md, grid.rowCenter)}>
                                        <Icon type="sadSmile" size={75} />
                                    </div>
                                    <div className={cn(grid.mb_md)}>
                                        <Typography
                                            type="title"
                                            className={cn(
                                                textStyles.centerBlock,
                                                textStyles['normalPlus'],
                                                grid.mb_mini
                                            )}
                                        >
                                            {translate('cantAddlicensesLeft')}
                                        </Typography>
                                    </div>
                                    <div className={cn(grid.mb_md)}>
                                        <Typography
                                            type="title"
                                            className={cn(
                                                textStyles.centerBlock,
                                                textStyles['normalPlus'],
                                                grid.mb_mini
                                            )}
                                        >
                                            <Link to={'/licenses'}>{translate('addLicensesSection')}</Link>
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={styles.footer}>
                        <Button className={grid.mr_mini} onClick={closeModal} mod="withBorder">
                            {translate('close')}
                        </Button>
                        <Button
                            mod="fill"
                            onClick={onSave}
                            disabled={
                                !helpersDisplays.isCheckLicenseQ()
                                    ? state.data.error || state.data.nullTimezoneError
                                        ? true
                                        : false
                                    : state.data.error || state.data.nullTimezoneError || state.data.licensesTypeError
                                    ? true
                                    : false
                            }
                        >
                            {translate('save')}
                        </Button>
                    </div>
                    {renderMap()}
                </form>
            </Scrollbars>
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        emitError: (err: string) => dispatch(emitError(err)),
        closeModal: () => dispatch(displaysActions.closeModal()),
    }
}

export default connect(
    (state: {
        displays: { tags: VirtualDeviceTagOption[] }
        app: { timezones: VirtualDeviceTimezoneOption[] }
        user: { data: { companyId: string } }
    }) => ({
        tagsList: state.displays.tags,
        timezones: state.app.timezones,
        user: state.user.data.companyId,
    }),
    mapDispatchToProps
)(DisplaysAddVirtualDevice)
